import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              常见问答
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              关于每日爆料，你想知道的都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((faq) => (
              <div
                key={faq.id}
                className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <div className="px-5 md:px-6 py-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 flex items-start gap-3">
                    <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                    <span>{faq.q}</span>
                  </h3>
                  <div className="mt-2 pl-7 flex items-start gap-3">
                    <span className="text-accent-600 flex-shrink-0 mt-0.5">A</span>
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}